import { render, staticRenderFns } from "./DebtiaLoading.vue?vue&type=template&id=63b0a9a8&"
import script from "./DebtiaLoading.vue?vue&type=script&lang=js&"
export * from "./DebtiaLoading.vue?vue&type=script&lang=js&"
import style0 from "./DebtiaLoading.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports